// import React, { useEffect, useRef, useState } from "react";
// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import { useLocation, useNavigate } from "react-router-dom";
// import Topbar from "../../../components/Topbar/Topbar";
// import Select from "react-select";
// import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
// import { delete_icon, dummyimage } from "../../../assets/img";
// import { URLS } from "../../../Services/Constant";
// import { get, post, put } from "../../../Services/ApiHandler";
// import { toast } from "react-toastify";

// const AddPropertyBanner = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const inputRefs = useRef([]);

//   const type = location?.state?.type;
//   const data = location?.state?.data;
//   const [state, setState] = useState(null);
//   const [city, setCity] = useState(null);
//   const [fromDate, setFormDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [errors, setErrors] = useState({});
//   const [status, setStatus] = useState("On Going");
//   const [blocks, setBlocks] = useState([]);
//   const [optionsList, setOptionsList] = useState({
//     states: [],
//     cities: [],
//   });
//   const [addedStateCities, setAddedStateCities] = useState({
//     states: new Set(),
//     cities: new Set(),
//   });
//   console.log("added state cities", addedStateCities);
//   useEffect(() => {
//     getLocationsList(2);
//     let viewId = location.state?.data?.id;
//     if (viewId) viewDetails(viewId);
//   }, []);

//   const checkAvailableLocations = async (from, to) => {
//     let payload = {
//       type: 2,
//       start_date: from,
//       end_date: to,
//       banner_id: data?.id,
//     };
//     let res = await post(URLS.BANNER_AVAILABILITY, payload);
//     console.log("banner availability", res);
//     if (res?.status === "success") {
//       let stateIds = new Set(res?.unavailable_states?.map((item) => item?.id));
//       let cityIds = new Set(res?.unavailable_cities?.map((item) => item?.id));
//       if (city && cityIds.has(city?.value)) setCity(null);
//       setAddedStateCities({
//         cities: cityIds,
//         states: stateIds,
//       });
//     }
//   };

//   const viewDetails = async (id) => {
//     let res = await get(`${URLS.BANNER_ADD}${id}/details/`);
//     console.log("banner view res", res);
//     if (res?.status === "success") {
//       let d = res?.data;
//       getLocationsList(3, d?.state);
//       setFormDate(d?.start_date);
//       setToDate(d?.end_date);
//       setState({ value: d?.state, label: d?.state_name });
//       setCity({ value: d?.city, label: d?.city_name });
//       checkAvailableLocations(d?.start_date, d?.end_date);
//       setBlocks(
//         (d?.images ?? [])?.map((item) => ({
//           ...item,
//           selectedImage: item?.image,
//           fromDate: item?.start_time,
//           toDate: item?.end_time,
//         })),
//       );
//     }
//   };

//   //get  locations
//   const getLocationsList = async (type, parent_id) => {
//     let url = `${URLS.LOCATION + "?type=" + type}${
//       parent_id ? "&parent_id=" + parent_id : ""
//     }`;
//     const res = await get(url);
//     console.log("locations list", res, type, parent_id);
//     if (res?.status === "success") {
//       const modifiedList = res?.data?.map((item) => {
//         return { value: item?.id, label: item?.name };
//       });
//       if (type === 2) {
//         setOptionsList((prev) => ({ ...prev, states: modifiedList }));
//       } else if (type === 3) {
//         setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
//       } else {
//         setOptionsList((prev) => ({ ...prev, areas: modifiedList }));
//       }
//     }
//   };

//   const handleAddBlock = () => {
//     setBlocks((prev) => [
//       ...prev,
//       {
//         selectedImage: "",
//         url: "",
//         fromDate: "",
//         toDate: "",
//       },
//     ]);
//   };

//   const handleDeleteBlock = (indexToDelete) => {
//     setBlocks((prev) => prev.filter((_, index) => index !== indexToDelete));
//   };

//   const handleChange = (index, field, value) => {
//     const updated = [...blocks];
//     updated[index][field] = value;
//     setBlocks(updated);
//   };

//   const handleImageChange = (index, file) => {
//     const updated = [...blocks];
//     updated[index].selectedImage = file;
//     updated[index]["id"] = null;
//     setBlocks(updated);
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     let isBannerHasEmptyFeild = false;
//     // Required selects
//     if (!state) newErrors.state = "State is required";
//     if (!city && addedStateCities.states.has(state?.value)) {
//       toast.error("This state already has banners. Please select a city.");
//       newErrors.city = "City is required";
//     }

//     // Required dates
//     if (!fromDate) newErrors.startDate = "Start date is required";
//     if (!toDate) newErrors.endDate = "End date is required";
//     else if (new Date(toDate) < new Date(fromDate)) {
//       newErrors.endDate = "End date cannot be before start date";
//     }

//     blocks.forEach((item) => {
//       Object.entries(item).forEach((val) => {
//         if (!val[1] && val[0] !== "id" && val[0] !== "url")
//           isBannerHasEmptyFeild = true;
//       });
//     });
//     if (blocks.length === 0 || isBannerHasEmptyFeild) {
//       toast.error(
//         blocks.length === 0
//           ? "Please Add Banners"
//           : "Please Fill All the Details",
//       );
//       newErrors.emptyFeild = "empty";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validateForm()) return;

//     let payload = new FormData();
//     console.log("state_kdjkads", state);

//     // Append simple fields
//     payload.append("type", 2);
//     payload.append("country", 1);
//     payload.append("state", state?.value || "");
//     payload.append("city", city?.value || "");
//     payload.append("start_date", fromDate || "");
//     payload.append("end_date", toDate || "");

//     // Append images array
//     blocks?.forEach((item, index) => {
//       if (type === "edit") {
//         if (Boolean(item?.id)) {
//           payload.append(`image_ids[]`, item.id);
//           payload.append(`urls[]`, item?.url || "");
//           payload.append(`start_times[]`, item?.fromDate || "");
//           payload.append(`end_times[]`, item?.toDate || "");
//         } else {
//           payload.append(`new_images[]`, item.selectedImage);
//           payload.append(`new_urls[]`, item?.url || "");
//           payload.append(`new_start_times[]`, item?.fromDate || "");
//           payload.append(`new_end_times[]`, item?.toDate || "");
//         }
//       } else {
//         // Append other properties
//         payload.append(`images[]`, item.selectedImage);
//         payload.append(`urls[]`, item?.url || "");
//         payload.append(`start_times[]`, item?.fromDate || "");
//         payload.append(`end_times[]`, item?.toDate || "");
//       }
//     });
//     console.log("payload banner", payload);
//     let method = type === "edit" ? put : post;
//     let res = await method(
//       `${URLS.BANNER_ADD}${type === "edit" ? `${data?.id}/edit` : "add"}/`,
//       payload,
//     );
//     if (res?.status === "success") {
//       toast.success(res?.message);
//       navigate(-1);
//     }
//   };
//   console.log("from data to date", fromDate, toDate, blocks);
//   return (
//     <div className="">
//       <Topbar header={type == "add" ? "Add Banner" : "Edit Banner"} />
//       <div className="d-flex flex-wrap gap-4">
//         <div className="col-md-5">
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
//             Country
//           </p>
//           <input
//             className="input-box"
//             name="userName"
//             readOnly
//             value={"India"}
//             type="text"
//             placeholder="User Name"
//           />
//         </div>
//         <div className="col-md-5">
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
//             State
//           </p>
//           <Select
//             className="select-loc"
//             options={optionsList.states}
//             value={state}
//             onChange={(selectedOption) => {
//               setState(selectedOption);
//               setErrors((prev) => ({ ...prev, state: "" }));
//               getLocationsList(3, selectedOption?.value);
//             }}
//             placeholder={"State"}
//           />
//           {errors.state && <p className="err">{errors.state}</p>}
//         </div>

//         <div className="col-md-5">
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
//             City
//           </p>
//           <Select
//             className="select-loc"
//             options={optionsList.cities?.filter(
//               (item) =>
//                 !addedStateCities.cities?.has(item?.value) ||
//                 item?.value === city?.value,
//             )}
//             value={city}
//             onChange={(selectedOption) => {
//               setCity(selectedOption);
//               setErrors((prev) => ({ ...prev, city: "" }));
//             }}
//             placeholder={"City"}
//           />
//           {errors.city && <p className="err">{errors.city}</p>}
//         </div>
//       </div>
//       <div className="d-flex gap-3 mt-4">
//         <div className="">
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
//             {" "}
//             Start Date
//           </p>
//           <input
//             type="date"
//             value={fromDate}
//             max={toDate}
//             onChange={(e) => {
//               const newValue = e.target.value;
//               setFormDate(newValue);
//               setErrors((prev) => ({
//                 ...prev,
//                 startDate: newValue ? "" : prev.startDate,
//                 endDate:
//                   toDate && new Date(toDate) >= new Date(newValue)
//                     ? ""
//                     : prev.endDate,
//               }));
//             }}
//             className="input-box "
//             placeholder="From Date"
//           />
//           {errors.startDate && <p className="err">{errors.startDate}</p>}
//         </div>
//         <div className="">
//           <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
//             {" "}
//             End Date
//           </p>
//           <input
//             type="date"
//             value={toDate}
//             min={fromDate}
//             onChange={(e) => {
//               const newValue = e.target.value;
//               setToDate(newValue);
//               checkAvailableLocations(fromDate, newValue);
//               setErrors((prev) => ({
//                 ...prev,
//                 endDate:
//                   newValue && new Date(newValue) >= new Date(fromDate)
//                     ? ""
//                     : prev.endDate,
//               }));
//             }}
//             className="input-box"
//             placeholder="To Date"
//           />
//           {errors.endDate && <p className="err">{errors.endDate}</p>}
//         </div>
//       </div>
//       <div className="mt-5">
//         <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
//           Upload Banner
//         </h2>
//         <p className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ">
//           {" "}
//           Max Size: 5MB | Aspect Ratio: 330:191 Supported Sizes: 660×382,
//           990×573, 1320×764
//         </p>
//       </div>

//       <div className="d-flex ae-jb gap-1 ">
//         {/* {type == "edit" && ( */}
//         <div className="col-md-8">
//           {blocks?.map((block, index) => (
//             <div className="roles-bg " key={index}>
//               <div className="d-flex ae-jb gap-2">
//                 <div className="position-relative w-10">
//                   <div
//                     className="position-relative w-100"
//                     onClick={() => inputRefs[index]?.click()}
//                   >
//                     <HighlightOffRoundedIcon
//                       className="img-cancel"
//                       style={{ height: "20px", width: "20px", zIndex: 0 }}
//                     />
//                     <div className="d-flex ac-jb w-100">
//                       <div>
//                         <img
//                           alt="preview"
//                           style={{ width: "50px", height: "50px" }}
//                           src={
//                             typeof block.selectedImage === "string"
//                               ? block.selectedImage || dummyimage
//                               : block.selectedImage
//                                 ? URL.createObjectURL(block.selectedImage)
//                                 : dummyimage
//                           }
//                         />
//                         <input
//                           ref={(el) => (inputRefs[index] = el)}
//                           type="file"
//                           hidden
//                           accept="image/*"
//                           onChange={(e) =>
//                             handleImageChange(index, e.target.files[0])
//                           }
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <input
//                   style={{ height: "30px" }}
//                   type="url"
//                   value={block.url}
//                   onChange={(e) => handleChange(index, "url", e.target.value)}
//                   className="input-box "
//                   placeholder="Enter URL"
//                 />

//                 <div className="d-flex gap-3">
//                   <div>
//                     <p className="f3 fs-xs-8">Start Time</p>
//                     <input
//                       style={{ height: "30px" }}
//                       type="time"
//                       value={block.fromDate}
//                       onChange={(e) => {
//                         handleChange(index, "fromDate", e.target.value);
//                         handleChange(index, "toDate", e.target.value);
//                       }}
//                       className="input-box"
//                     />
//                   </div>
//                   <div>
//                     <p className="f3 fs-xs-8">End Time</p>
//                     <input
//                       style={{ height: "30px" }}
//                       type="time"
//                       value={block.toDate}
//                       min={block.fromDate}
//                       onChange={(e) => {
//                         let formattedTo = Number(
//                           e.target.value?.replace(":", ""),
//                         );
//                         let formattedFrom = Number(
//                           block.fromDate?.replace(":", ""),
//                         );
//                         if (formattedTo > formattedFrom)
//                           handleChange(index, "toDate", e.target.value);
//                       }}
//                       className="input-box"
//                     />
//                   </div>
//                 </div>
//                 {type === "edit" && (
//                   <input
//                     type="text"
//                     value={block?.status}
//                     style={{ height: "30px", width: "100px" }}
//                     className={`${
//                       block?.status === "ongoing" ? "bg-green white" : ""
//                     } input-box text-center`}
//                     disabled
//                   />
//                 )}

//                 {/* {type === "add" && blocks.length != 1 && ( */}
//                 <button
//                   className="cust-btn"
//                   onClick={() => handleDeleteBlock(index)}
//                   type="button"
//                 >
//                   <img src={delete_icon} alt="" className="mx-2 edit-btn" />
//                 </button>
//                 {/* )} */}
//               </div>
//             </div>
//           ))}
//         </div>
//         {/* )} */}
//         <button
//           onClick={handleAddBlock}
//           className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
//         >
//           Add
//         </button>
//       </div>
//       {errors.blocks && <p className="err">{errors.blocks}</p>}
//       <div className="d-flex ac-js gap-3 mt-5">
//         <button
//           onClick={() => navigate("/home-banners")}
//           className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
//           style={{ minWidth: "20%" }}
//         >
//           Cancel
//         </button>
//         {type != "view" && (
//           <button
//             onClick={handleSubmit}
//             className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
//             style={{ minWidth: "20%" }}
//           >
//             {type == "edit" ? "Submit" : "Add"}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddPropertyBanner;
import React, { useCallback, useEffect, useRef, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import Select from "react-select";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { delete_icon, dummyimage } from "../../../assets/img";
import { URLS } from "../../../Services/Constant";
import { get, post, put } from "../../../Services/ApiHandler";
import { toast } from "react-toastify";

const ALL_STATES_OPTION = { value: "all", label: "All States" };
const ALL_CITIES_OPTION = { value: "all", label: "All Cities" };

const AddPropertyBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const inputRefs = useRef([]);

  const [unavailableStateIds, setUnavailableStateIds] = useState([]);
  const [unavailableCityIds, setUnavailableCityIds] = useState([]);

  const type = location?.state?.type || "add";
  const data = location?.state?.data;

  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [allStatesSelected, setAllStatesSelected] = useState(false);
  const [allCitiesSelected, setAllCitiesSelected] = useState(false);

  const [fromDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("On Going");
  const [blocks, setBlocks] = useState([]);
  const [optionsList, setOptionsList] = useState({
    states: [],
    cities: [],
  });

  const getStatesList = useCallback(async () => {
    try {
      const res = await get(`${URLS.LOCATION}?type=2`);
      if (res?.status === "success") {
        const list = res.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionsList((prev) => ({ ...prev, states: list }));
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Failed to load states");
    }
  }, []);

  const getCitiesList = useCallback(async (stateIds = []) => {
    if (!stateIds.length) {
      setOptionsList((prev) => ({ ...prev, cities: [] }));
      return;
    }
    try {
      const results = await Promise.all(
        stateIds.map((id) => get(`${URLS.LOCATION}?type=3&parent_id=${id}`)),
      );
      const combined = results.flatMap((res) =>
        res?.status === "success"
          ? res.data.map((item) => ({ value: item.id, label: item.name }))
          : [],
      );
      const unique = Array.from(
        new Map(combined.map((c) => [c.value, c])).values(),
      );
      setOptionsList((prev) => ({ ...prev, cities: unique }));
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to load cities");
    }
  }, []);

  const checkAvailableLocations = useCallback(
    async (from, to) => {
      if (!from || !to) return;
      try {
        const payload = {
          type: 2,
          start_date: from,
          end_date: to,
          banner_id: data?.id,
        };
        const res = await post(URLS.BANNER_AVAILABILITY, payload);
        if (res?.status === "success") {
          setUnavailableStateIds(res.unavailable_states || []);
          setUnavailableCityIds(res.unavailable_cities || []);
        }
      } catch (error) {
        console.error("Error checking availability:", error);
        toast.error("Failed to check availability");
      }
    },
    [data?.id],
  );

  const viewDetails = useCallback(
    async (id) => {
      try {
        const res = await get(`${URLS.BANNER_ADD}${id}/details/`);
        if (res?.status === "success") {
          const d = res.data;
          setFormDate(d.start_date || "");
          setToDate(d.end_date || "");
          await checkAvailableLocations(d.start_date, d.end_date);

          if (d.all_states) {
            setAllStatesSelected(true);
            setAllCitiesSelected(true);
            setSelectedStates([ALL_STATES_OPTION]);
            setSelectedCities([ALL_CITIES_OPTION]);
          } else {
            const stateOptions = (d.states_detail || []).map((s) => ({
              value: s.id,
              label: s.name,
            }));
            const cityOptions = (d.cities_detail || []).map((c) => ({
              value: c.id,
              label: c.name,
            }));
            setSelectedStates(stateOptions);
            setSelectedCities(cityOptions);
            setAllStatesSelected(false);
            setAllCitiesSelected(cityOptions.length === 0);

            if (stateOptions.length) {
              getCitiesList(stateOptions.map((s) => s.value));
            }
          }

          setBlocks(
            (d?.images ?? [])?.map((item) => ({
              ...item,
              selectedImage: item?.image,
              fromDate: item?.start_time,
              toDate: item?.end_time,
            })),
          );
        }
      } catch (error) {
        console.error("Error loading details:", error);
        toast.error("Failed to load banner details");
      }
    },
    [checkAvailableLocations, getCitiesList],
  );

  const hasInitialized = useRef(false);

  useEffect(() => {
    getStatesList();
  }, [getStatesList]);

  useEffect(() => {
    if (type === "edit" && data?.id && !hasInitialized.current) {
      hasInitialized.current = true;
      viewDetails(data.id);
    }
  }, [type, data?.id, viewDetails]);

  const handleStateChange = (selectedOptions) => {
    const hasAll = selectedOptions?.some((o) => o.value === "all");

    if (hasAll) {
      setAllStatesSelected(true);
      setAllCitiesSelected(true);
      setSelectedStates([ALL_STATES_OPTION]);
      setSelectedCities([ALL_CITIES_OPTION]);
      setOptionsList((prev) => ({ ...prev, cities: [] }));
    } else {
      setAllStatesSelected(false);
      setAllCitiesSelected(false);
      setSelectedStates(selectedOptions || []);
      setSelectedCities([]);
      const ids = (selectedOptions || []).map((s) => s.value);
      if (ids.length) getCitiesList(ids);
      else setOptionsList((prev) => ({ ...prev, cities: [] }));
    }
    setErrors((prev) => ({ ...prev, state: "" }));
  };

  const handleCityChange = (selectedOptions) => {
    const hasAll = selectedOptions?.some((o) => o.value === "all");
    if (hasAll) {
      setAllCitiesSelected(true);
      setSelectedCities([ALL_CITIES_OPTION]);
    } else {
      setAllCitiesSelected(false);
      setSelectedCities(selectedOptions || []);
    }
    setErrors((prev) => ({ ...prev, city: "" }));
  };

  const handleAddBlock = () => {
    setBlocks((prev) => [
      ...prev,
      {
        selectedImage: "",
        url: "",
        fromDate: "",
        toDate: "",
      },
    ]);
  };

  const handleDeleteBlock = (indexToDelete) => {
    setBlocks((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleChange = (index, field, value) => {
    const updated = [...blocks];
    updated[index][field] = value;
    setBlocks(updated);
  };

  const handleImageChange = (index, file) => {
    const updated = [...blocks];
    updated[index].selectedImage = file;
    updated[index]["id"] = null;
    setBlocks(updated);
  };

  const validateForm = () => {
    const newErrors = {};
    let isBannerHasEmptyFeild = false;

    // Required selects
    if (!allStatesSelected && selectedStates.length === 0) {
      newErrors.state = "State is required";
    }

    // Required dates
    if (!fromDate) newErrors.startDate = "Start date is required";
    if (!toDate) newErrors.endDate = "End date is required";
    else if (new Date(toDate) < new Date(fromDate)) {
      newErrors.endDate = "End date cannot be before start date";
    }

    blocks.forEach((item) => {
      Object.entries(item).forEach((val) => {
        if (!val[1] && val[0] !== "id" && val[0] !== "url")
          isBannerHasEmptyFeild = true;
      });
    });
    if (blocks.length === 0 || isBannerHasEmptyFeild) {
      toast.error(
        blocks.length === 0
          ? "Please Add Banners"
          : "Please Fill All the Details",
      );
      newErrors.emptyFeild = "empty";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    let payload = new FormData();

    // Append simple fields
    payload.append("type", 2);
    payload.append("country", 1);

    // ✅ Pass all_states flag + states/cities as JSON arrays
    if (allStatesSelected) {
      payload.append("all_states", "true");
      payload.append("states", JSON.stringify([]));
      payload.append("cities", JSON.stringify([]));
    } else {
      payload.append("all_states", "false");
      const stateIds = selectedStates.map((s) => s.value);
      const cityIds = allCitiesSelected
        ? []
        : selectedCities.map((c) => c.value);
      payload.append("states", JSON.stringify(stateIds));
      payload.append("cities", JSON.stringify(cityIds));
    }

    payload.append("start_date", fromDate || "");
    payload.append("end_date", toDate || "");

    // Append images array
    blocks?.forEach((item, index) => {
      if (type === "edit") {
        if (Boolean(item?.id)) {
          payload.append(`image_ids[]`, item.id);
          payload.append(`urls[]`, item?.url || "");
          payload.append(`start_times[]`, item?.fromDate || "");
          payload.append(`end_times[]`, item?.toDate || "");
        } else {
          payload.append(`new_images[]`, item.selectedImage);
          payload.append(`new_urls[]`, item?.url || "");
          payload.append(`new_start_times[]`, item?.fromDate || "");
          payload.append(`new_end_times[]`, item?.toDate || "");
        }
      } else {
        // Append other properties
        payload.append(`images[]`, item.selectedImage);
        payload.append(`urls[]`, item?.url || "");
        payload.append(`start_times[]`, item?.fromDate || "");
        payload.append(`end_times[]`, item?.toDate || "");
      }
    });

    let method = type === "edit" ? put : post;
    let res = await method(
      `${URLS.BANNER_ADD}${type === "edit" ? `${data?.id}/edit` : "add"}/`,
      payload,
    );
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate(-1);
    }
  };

  const stateOptions = [
    ...(unavailableStateIds.length === 0 ? [ALL_STATES_OPTION] : []),
    ...optionsList.states.filter(
      (s) =>
        !unavailableStateIds.some(
          (unavailable) => unavailable.id === s.value,
        ) || selectedStates.some((sel) => sel.value === s.value),
    ),
  ];

  const selectedStateIds = selectedStates.map((s) => s.value);
  const hasUnavailableCityInSelectedStates = unavailableCityIds.some((city) =>
    selectedStateIds.includes(city.state_id),
  );

  const cityOptions = allStatesSelected
    ? [ALL_CITIES_OPTION]
    : [
        ...(!hasUnavailableCityInSelectedStates ? [ALL_CITIES_OPTION] : []),
        ...optionsList.cities.filter(
          (c) =>
            !unavailableCityIds.some(
              (unavailable) => unavailable.id === c.value,
            ) || selectedCities.some((sel) => sel.value === c.value),
        ),
      ];

  return (
    <div className="">
      <Topbar header={type == "add" ? "Add Banner" : "Edit Banner"} />

      <div className="d-flex gap-3 mt-4">
        <div className="">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            {" "}
            Start Date
          </p>
          <input
            type="date"
            value={fromDate}
            max={toDate}
            onChange={(e) => {
              const newValue = e.target.value;
              setFormDate(newValue);
              setErrors((prev) => ({
                ...prev,
                startDate: newValue ? "" : prev.startDate,
                endDate:
                  toDate && new Date(toDate) >= new Date(newValue)
                    ? ""
                    : prev.endDate,
              }));
            }}
            className="input-box "
            placeholder="From Date"
          />
          {errors.startDate && <p className="err">{errors.startDate}</p>}
        </div>
        <div className="">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            {" "}
            End Date
          </p>
          <input
            type="date"
            value={toDate}
            min={fromDate}
            onChange={(e) => {
              const newValue = e.target.value;
              setToDate(newValue);
              checkAvailableLocations(fromDate, newValue);
              setErrors((prev) => ({
                ...prev,
                endDate:
                  newValue && new Date(newValue) >= new Date(fromDate)
                    ? ""
                    : prev.endDate,
              }));
            }}
            className="input-box"
            placeholder="To Date"
          />
          {errors.endDate && <p className="err">{errors.endDate}</p>}
        </div>
      </div>

      <div className="d-flex flex-wrap gap-4 mt-5">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Country
          </p>
          <input
            className="input-box"
            name="userName"
            readOnly
            value={"India"}
            type="text"
            placeholder="User Name"
          />
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            State
          </p>
          <Select
            className="select-loc"
            options={stateOptions}
            value={allStatesSelected ? [ALL_STATES_OPTION] : selectedStates}
            onChange={handleStateChange}
            placeholder={"Select State(s)"}
            isMulti
            closeMenuOnSelect={false}
            isDisabled={!fromDate || !toDate}
          />
          {errors.state && <p className="err">{errors.state}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            City
          </p>
          <Select
            className="select-loc"
            options={cityOptions}
            value={
              allStatesSelected || allCitiesSelected
                ? [ALL_CITIES_OPTION]
                : selectedCities
            }
            onChange={handleCityChange}
            placeholder={
              allStatesSelected
                ? "All Cities (auto-selected)"
                : "Select City(s)"
            }
            isMulti
            isDisabled={!fromDate || !toDate || allStatesSelected}
            closeMenuOnSelect={false}
            // isDisabled={}
          />
          {errors.city && <p className="err">{errors.city}</p>}
        </div>
      </div>

      <div className="d-flex flex-wrap gap-4 mt-5">
        {unavailableStateIds.length > 0 && (
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              UnAvalible State
            </p>
            <div
              className="select-loc"
              style={{
                background: "#f4f4f4",
                padding: "10px 20px",
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              {unavailableStateIds?.map((ele) => (
                <p
                  key={ele.id}
                  style={{
                    background: "#828282",
                    borderRadius: 10,
                    color: "#fff",
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                >
                  {ele?.name}
                </p>
              ))}
            </div>
          </div>
        )}
        {unavailableCityIds.length > 0 && (
          <div className="col-md-5">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              UnAvalible City
            </p>
            <div
              className="select-loc"
              style={{
                background: "#f4f4f4",
                padding: "10px 20px",
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              {unavailableCityIds.map((ele) => (
                <p
                  key={ele.id}
                  style={{
                    background: "#828282",
                    borderRadius: 10,
                    color: "#fff",
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                >
                  {ele?.name}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="mt-5">
        <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
          Upload Banner
        </h2>
        <p className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ">
          {" "}
          Max Size: 5MB | Aspect Ratio: 330:191 Supported Sizes: 660×382,
          990×573, 1320×764
        </p>
      </div>

      <div className="d-flex ae-jb gap-1 ">
        <div className="col-md-8">
          {blocks?.map((block, index) => (
            <div className="roles-bg " key={index}>
              <div className="d-flex ae-jb gap-2">
                <div className="position-relative w-10">
                  <div
                    className="position-relative w-100"
                    onClick={() => inputRefs[index]?.click()}
                  >
                    <HighlightOffRoundedIcon
                      className="img-cancel"
                      style={{ height: "20px", width: "20px", zIndex: 0 }}
                    />
                    <div className="d-flex ac-jb w-100">
                      <div>
                        <img
                          alt="preview"
                          style={{ width: "50px", height: "50px" }}
                          src={
                            typeof block.selectedImage === "string"
                              ? block.selectedImage || dummyimage
                              : block.selectedImage
                                ? URL.createObjectURL(block.selectedImage)
                                : dummyimage
                          }
                        />
                        <input
                          ref={(el) => (inputRefs[index] = el)}
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={(e) =>
                            handleImageChange(index, e.target.files[0])
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <input
                  style={{ height: "30px" }}
                  type="url"
                  value={block.url}
                  onChange={(e) => handleChange(index, "url", e.target.value)}
                  className="input-box "
                  placeholder="Enter URL"
                />

                <div className="d-flex gap-3">
                  <div>
                    <p className="f3 fs-xs-8">Start Time</p>
                    <input
                      style={{ height: "30px" }}
                      type="time"
                      value={block.fromDate}
                      onChange={(e) => {
                        handleChange(index, "fromDate", e.target.value);
                        handleChange(index, "toDate", e.target.value);
                      }}
                      className="input-box"
                    />
                  </div>
                  <div>
                    <p className="f3 fs-xs-8">End Time</p>
                    <input
                      style={{ height: "30px" }}
                      type="time"
                      value={block.toDate}
                      min={block.fromDate}
                      onChange={(e) => {
                        let formattedTo = Number(
                          e.target.value?.replace(":", ""),
                        );
                        let formattedFrom = Number(
                          block.fromDate?.replace(":", ""),
                        );
                        if (formattedTo > formattedFrom)
                          handleChange(index, "toDate", e.target.value);
                      }}
                      className="input-box"
                    />
                  </div>
                </div>
                {type === "edit" && (
                  <input
                    type="text"
                    value={block?.status}
                    style={{ height: "30px", width: "100px" }}
                    className={`${
                      block?.status === "ongoing" ? "bg-green white" : ""
                    } input-box text-center`}
                    disabled
                  />
                )}

                <button
                  className="cust-btn"
                  onClick={() => handleDeleteBlock(index)}
                  type="button"
                >
                  <img src={delete_icon} alt="" className="mx-2 edit-btn" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={handleAddBlock}
          className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Add
        </button>
      </div>
      {errors.blocks && <p className="err">{errors.blocks}</p>}
      <div className="d-flex ac-js gap-3 mt-5">
        <button
          onClick={() => navigate("/home-banners")}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          style={{ minWidth: "20%" }}
        >
          Cancel
        </button>
        {type != "view" && (
          <button
            onClick={handleSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            style={{ minWidth: "20%" }}
          >
            {type == "edit" ? "Submit" : "Add"}
          </button>
        )}
      </div>
    </div>
  );
};

export default AddPropertyBanner;
